@if (visible) {
	<div class="install-banner" role="note">
		<img src="assets/icons/64.png" alt="" class="install-icon" />
		<p class="install-text">
			@if (device === 'ios') {
				{{ 'installBanner.iosBefore' | transloco }}
				<lucide-icon name="Share" [size]="14" class="inline-icon" aria-hidden="true"></lucide-icon>
				{{ 'installBanner.iosAfter' | transloco }}
			} @else if (installPrompt) {
				{{ 'installBanner.androidPrompt' | transloco }}
			} @else {
				{{ 'installBanner.androidMenu' | transloco }}
			}
		</p>
		@if (device === 'android' && installPrompt) {
			<button type="button" class="install-action" (click)="install()">{{ 'installBanner.install' | transloco }}</button>
		}
		<button type="button" class="install-close" [attr.aria-label]="'common.actions.close' | transloco" (click)="dismiss()">
			<lucide-icon name="X" [size]="16" aria-hidden="true"></lucide-icon>
		</button>
	</div>
}
